import { useCallback } from "react";
import { api } from "../utils/apiHandler";
import type { AxiosResponse } from "axios";
import type { Language } from "./types/languageTypes";

const LANGUAGES_PATH = "/languages";

const useLanguagesResource = () => {
  // Fetch all languages
  const getLanguages = useCallback(async (): Promise<Language[]> => {
    const response: AxiosResponse<Language[]> = await api.request<
      undefined,
      AxiosResponse<Language[]>
    >({
      method: "GET",
      url: LANGUAGES_PATH,
    });
    return response.data;
  }, []);

  // Fetch a specific language
  const getLanguage = useCallback(async (id: string): Promise<Language> => {
    const response: AxiosResponse<Language> = await api.request<
      undefined,
      AxiosResponse<Language>
    >({
      method: "GET",
      url: `${LANGUAGES_PATH}/${id}`,
    });
    return response.data;
  }, []);

  return { getLanguages, getLanguage };
};

export default useLanguagesResource;
